import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import * as countryTimezone from 'country-timezone';
import { CountryCode } from '../../app/shared/country-code';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

declare var $: any;

interface Employee {
  employee_id: string;
  employee_name: string;
  user_type?:string;
}

interface Industry {
  _id: string;
  name: string;
}

@Component({
  selector: 'app-department-edit-page',
  templateUrl: './department-edit-page.component.html',
  styleUrls: ['./department-edit-page.component.css']
})
export class DepartmentEditPageComponent implements OnInit {

  constructor(
    private api: ServiceService,
    private route: ActivatedRoute,
    private location: Location
  ) { }
  isLoading: boolean = false;
  // ============================
  // MAIN MODEL FOR SUBMIT
  // ============================
  model: any = {
    department_id: '',
    department_Foreman_id: '',
    department_Foreman_name: '',
    department_latitude: '',
    department_longitude: '',
    members: [],
    new_product_id_creator: '',
    new_product_id_creator_name: '',
    accounts_members: [],
    store_incharge_employee_id: '',
    safety_responsible_employee_id: '',
    helper_members: [],
    industry_types: [],
    work_in_time: '',
    lunch_out_time: '',
    lunch_in_time: '',
    work_out_time: '',
    warehouse_id: '',
    warehouse_name: '',
    country_name: '',
    timezone: '',
    public_holidays: [],
    is_factory: false,
    is_technician_available: false,
    has_new_product_request: false,
    cash_customers: [],
    weekly_working_days: [],
    weekly_time_schedule: [],
    rft_technicians: [],
    rft_brands: [],
    driver_delivery_employees: []

  };

  // ============================
  // FOREMAN SEARCH
  // ============================
  foremanSearch = '';
  foremanList: Employee[] = [];
  showForemanList = false;

  onForemanSearch() {
    if (!this.foremanSearch.trim()) {
      this.showForemanList = false;
      return;
    }

    this.api.ViewAllEmployee().subscribe((res) => {
      this.foremanList = res.data.filter((e: any) =>
        e.employee_name.toLowerCase().includes(this.foremanSearch.toLowerCase())
      );
      this.showForemanList = true;
    });
  }

  selectForeman(emp: Employee) {
    this.model.department_Foreman_id = emp.employee_id;
    this.model.department_Foreman_name = emp.employee_name;
    this.foremanSearch = emp.employee_name;
    this.showForemanList = false;
  }


  // ============================
  // WAREHOUSE
  // ============================
  warehouseSearch = '';
  warehouseList: any[] = [];
  showWarehouseList = false;

  loadWarehouses() {
    this.api.Warehouse_Dropdown().subscribe(res => {
      this.warehouseList = res.data;
    });
  }

  selectWarehouse(w: any) {
    this.model.warehouse_id = w.warehouse_id;
    this.model.warehouse_name = w.warehouse_name;

    this.warehouseSearch = w.warehouse_name;
    this.showWarehouseList = false;
  }


  onWarehouseSearchChange() {
    // When user clears the warehouse text box
    if (!this.warehouseSearch || !this.warehouseSearch.trim()) {
      this.showWarehouseList = false;

      // 🔹 Important: clear the selected warehouse from the model
      this.model.warehouse_id = '';
      this.model.warehouse_name = '';

      return;
    }

    // When user is typing something → show dropdown
    this.showWarehouseList = true;
  }

  // ============================
  // CUSTOMERS
  // ============================
  customerList: any[] = [];

  loadCustomers() {
    this.api.customerDropdown().subscribe(res => {
      this.customerList = res.data;
    });
  }

  // ============================
  // MEMBER / ACCOUNTS / HELPER
  // ============================
  allEmployees: Employee[] = [];
  assignedEmployee: Employee | null = null;
  selectedStoreResponsible: Employee | null = null;
  selectedSafetyResponsible: Employee | null = null;
  memberSearch = '';
  accMemberSearch = '';
  helperSearch = '';
  memberListFiltered: Employee[] = [];
  // Assigned Employee for Sale Order


  loadEmployees() {
    this.api.ViewAllEmployee().subscribe((res) => {
      this.allEmployees = res.data;
      this.memberListFiltered = [...this.allEmployees];
    });
  }
  onNewProductIdCreatorChange(emp: Employee) {
    if (emp) {
      this.model.new_product_id_creator = emp.employee_id;
      this.model.new_product_id_creator_name = emp.employee_name;
    } else {
      this.model.new_product_id_creator = '';
      this.model.new_product_id_creator_name = '';
    }
  }
onStoreResponsibleChange(emp: Employee | null) {
    this.model.store_incharge_employee_id = emp ? emp.employee_id : '';
  }

  onSafetyResponsibleChange(emp: Employee | null) {
    this.model.safety_responsible_employee_id = emp ? emp.employee_id : '';
  }
  searchMembers() {
    const term = this.memberSearch.toLowerCase();
    this.memberListFiltered = this.allEmployees.filter(e =>
      e.employee_name.toLowerCase().includes(term)
    );
  }

  searchAccMembers() {
    const term = this.accMemberSearch.toLowerCase();
    this.memberListFiltered = this.allEmployees.filter(e =>
      e.employee_name.toLowerCase().includes(term)
    );
  }

  searchHelperMembers() {
    const term = this.helperSearch.toLowerCase();
    this.memberListFiltered = this.allEmployees.filter(e =>
      e.employee_name.toLowerCase().includes(term)
    );
  }

  isMemberSelected(emp: Employee) {
    return this.model.members.some((m: any) => m.employee_id === emp.employee_id);
  }
  toggleMember(emp: Employee) {
    if (this.isMemberSelected(emp)) {
      this.model.members = this.model.members.filter((m: any) => m.employee_id !== emp.employee_id);
    } else {
      this.model.members.push(emp);
    }
  }

  isAccSelected(emp: Employee) {
    return this.model.accounts_members.some((m: any) => m.employee_id === emp.employee_id);
  }
  toggleAcc(emp: Employee) {
    if (this.isAccSelected(emp)) {
      this.model.accounts_members = this.model.accounts_members.filter((m: any) => m.employee_id !== emp.employee_id);
    } else {
      this.model.accounts_members.push(emp);
    }
  }

  isHelperSelected(emp: Employee) {
    return this.model.helper_members.some((m: any) => m.employee_id === emp.employee_id);
  }
  toggleHelper(emp: Employee) {
    if (this.isHelperSelected(emp)) {
      this.model.helper_members = this.model.helper_members.filter((m: any) => m.employee_id !== emp.employee_id);
    } else {
      this.model.helper_members.push(emp);
    }
  }
  technicianSearch = '';

  searchTechnicians() {
    const term = this.technicianSearch.toLowerCase();
    this.memberListFiltered = this.allEmployees.filter(e =>
      e.employee_name.toLowerCase().includes(term)
    );
  }

  isTechnicianSelected(emp: Employee) {
    return this.model.rft_technicians.some((t: any) => t.technician_id === emp.employee_id);
  }
  toggleTechnician(emp: Employee) {
    if (this.isTechnicianSelected(emp)) {
      this.model.rft_technicians = this.model.rft_technicians.filter((t: any) => t.technician_id !== emp.employee_id);
    } else {
      this.model.rft_technicians.push({ technician_id: emp.employee_id, technician_name: emp.employee_name });
    }
  }

  brandSearch = '';
  brandListFiltered: any[] = [];

  searchBrands() {
    const term = this.brandSearch.toLowerCase();
    this.brandListFiltered = this.brandList.filter(b =>
      (b.brand_name || '').toLowerCase().includes(term)
    );
  }

  isBrandSelected(brand: any) {
    return this.model.rft_brands.some((b: any) => b.brand_id === brand.brand_id);
  }

  toggleBrand(brand: any) {
    if (this.isBrandSelected(brand)) {
      this.model.rft_brands = this.model.rft_brands.filter((b: any) => b.brand_id !== brand.brand_id);
    } else {
      this.model.rft_brands.push(brand);
    }
  }

  deliveryManSearch = '';
  allDeliveryMen: Employee[] = [];
  deliveryManListFiltered: Employee[] = [];

  loadDeliveryMen() {
  this.api.ViewAllDeliveryMen(["Driver", "Delivery_Man"]).subscribe((res) => {
    this.allDeliveryMen = res.data || [];
    this.deliveryManListFiltered = [...this.allDeliveryMen];
    this.loadDepartment();
  });
}
  searchDeliveryMen() {
    const term = this.deliveryManSearch.toLowerCase();
    this.deliveryManListFiltered = this.allDeliveryMen.filter(d =>
      d.employee_name.toLowerCase().includes(term)
    );
  }

  isDeliveryManSelected(d: Employee) {
  return this.model.driver_delivery_employees.some((m: any) => m.employee_id === d.employee_id);
}

toggleDeliveryMan(d: Employee) {
  if (this.isDeliveryManSelected(d)) {
    this.model.driver_delivery_employees = this.model.driver_delivery_employees.filter((m: any) => m.employee_id !== d.employee_id);
  } else {
    this.model.driver_delivery_employees.push({
      employee_id: d.employee_id,
      employee_name: d.employee_name,
      // user_type: d.user_type
    });
  }
}
  // ============================
  // INDUSTRY TYPES
  // ============================
  industryList: Industry[] = [];
  selectedIndustry: any = null;
  industrySearch = '';

  loadIndustryTypes() {
    this.api.industryType().subscribe(res => {
      this.industryList = res.data;
    });
  }

  isIndustrySelected(ind: Industry) {
    return this.model.industry_types.some((i: any) => i.industry_type_id === ind._id);
  }

  toggleIndustry(ind: Industry) {
    if (!this.isIndustrySelected(ind)) {
      this.selectedIndustry = ind;
      this.industryTime = '';
      $('#industryTimeModal').modal('show');
    } else {
      this.model.industry_types = this.model.industry_types.filter((i: any) => i.industry_type_id !== ind._id);
    }
  }

  industryTime = '';
  invalidTime = false;

  validateTime() {
    const pattern = /^(\d{2}):([0-5]\d):([0-5]\d)$/;
    this.invalidTime = !pattern.test(this.industryTime);
  }

  saveIndustryTime() {
    this.model.industry_types.push({
      industry_type_id: this.selectedIndustry._id,
      industry_type_name: this.selectedIndustry.name,
      estimated_time: this.industryTime
    });

    $('#industryTimeModal').modal('hide');
  }

  // ============================
  // WEEKLY WORKING DAYS
  // ============================
  // NEW
  weekdays = [
    { week: 'Sunday', value: 1, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Monday', value: 2, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Tuesday', value: 3, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Wednesday', value: 4, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Thursday', value: 5, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Friday', value: 6, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
    { week: 'Saturday', value: 7, checked: false, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' },
  ];

  toggleWeekday(day: any) {
    day.checked = !day.checked;
    this.model.weekly_working_days = this.weekdays
      .filter(d => d.checked)
      .map(d => d.value);
  }

  private buildWeeklyTimeSchedule() {
    return this.weekdays
      .map(day => ({
        day: day.value,
        workin_time: day.workin_time || '',
        workout_time: day.workout_time || '',
        lunch_in_time: day.lunch_in_time || '',
        lunch_out_time: day.lunch_out_time || '',
        isActive: day.checked
      }));
  }

  // ============================
  // PUBLIC HOLIDAYS
  // ============================
  newHoliday = '';

  addHoliday() {
    if (this.newHoliday && !this.model.public_holidays.includes(this.newHoliday)) {
      this.model.public_holidays.push(this.newHoliday);
      this.newHoliday = '';
    }
  }

  removeSelectedHoliday() {
    const selectEl: any = document.querySelector('select.form-control');
    const selected = Array.from(selectEl.selectedOptions).map((opt: any) => opt.value);

    this.model.public_holidays = this.model.public_holidays.filter(
      (h: any) => !selected.includes(h)
    );
  }
  brandList: any[] = [];

  loadBrands() {
    this.api.BrandDropdown().subscribe(res => {
      this.brandList = res.data;
      this.brandListFiltered = [...this.brandList];
    });
  }

  // onBrandSelected(brand: any) {
  //   if (brand) {
  //     this.model.brand_id = brand.brand_id;
  //     this.model.brand_name = brand.brand_name;
  //   } else {
  //     this.model.brand_id = '';
  //     this.model.brand_name = '';
  //   }
  // }
  // ============================
  // COUNTRY + TIMEZONE
  // ============================
  countries = CountryCode;
  selectedCountry: any = null;
  timezoneList: string[] = [];

  onCountrySelected(event: any) {
    this.timezoneList = countryTimezone.getTimezones(event.name);
    this.model.country_name = event.name;
  }

  // ============================
  // GOOGLE MAPS
  // ============================
  mapLoaded = false;
  mapCenter = { lat: 24.4539, lng: 54.3773 };
  mapZoom = 12;
  mapMarkers: any[] = [];

  loadGoogleMaps() {
    this.api.loadGoogleMaps('AIzaSyBOQ9-zria589tItgtGZsbzwORm6T5_c5U')
      .then(() => this.mapLoaded = true)
      .catch(() => this.mapLoaded = false);
  }

  onMapClick(event: any) {
    const pos = event.latLng.toJSON();
    this.model.department_latitude = pos.lat;
    this.model.department_longitude = pos.lng;

    this.mapMarkers = [{
      position: pos,
      label: { text: 'Department Location', color: 'red' },
      options: { animation: google.maps.Animation.BOUNCE }
    }];
  }

  // ============================
  // LOAD DEPARTMENT DETAILS
  // ============================

  loadDepartment() {
    // 1. Try to read from URL: /admin/department-edit-page?id=...
    const idFromRoute = this.route.snapshot.queryParamMap.get('id');

    // 2. Fallback to service (if you still use getDepartmentId() anywhere)
    const idFromService = (this.api as any).getDepartmentId
      ? this.api.getDepartmentId()
      : null;

    const id = idFromRoute || idFromService;

    if (!id) {
      console.warn('No department_id found for edit page');
      return;
    }

    this.api.ViewDepartmentID(id).subscribe((res) => {
      if (!res || !res.data || !res.data[0]) {
        console.error('Department not found');
        return;
      }

      const d = res.data[0];

      this.model = {
        ...this.model,
        department_id: d.department_id,
        department_Foreman_id: d.department_Foreman_id,
        department_Foreman_name: d.department_Foreman_name,
        warehouse_id: d.warehouse_id,
        warehouse_name: d.warehouse_name,
        department_latitude: d.department_latitude,
        department_longitude: d.department_longitude,
        work_in_time: d.work_in_time,
        work_out_time: d.work_out_time,
        lunch_in_time: d.lunch_in_time,
        lunch_out_time: d.lunch_out_time,
        members: d.members || [],
        accounts_members: d.accounts_members || [],
        helper_members: d.helper_members || [],
        industry_types: d.industry_types || [],
        cash_customers: d.cash_customers?.map((c: any) => c.customer_id) || [],
        public_holidays: d.public_holidays || [],
        is_factory: d.is_factory || false,
        is_technician_available: d.is_technician_available || false,
        has_new_product_request: d.has_new_product_request || false,
        new_product_id_creator: d.new_product_id_creator || '',
        new_product_id_creator_name: d.new_product_id_creator_name || '',
        store_incharge_employee_id: d.store_incharge_employee_id || '',
        safety_responsible_employee_id: d.safety_responsible_employee_id || '',
        rft_technicians: d.rft_technicians || [],
        rft_brands: d.rft_brands || [],
        driver_delivery_employees: (d.driver_delivery_employees || []).map((emp: any) => ({
  employee_id: emp.employee_id,
  employee_name: emp.employee_name,
  user_type: this.allDeliveryMen.find(a => a.employee_id === emp.employee_id)?.user_type || ''
})),
        country_name: d.country_name,
        timezone: d.timezone,
        weekly_working_days: d.weekly_working_days || [],
        weekly_time_schedule: d.weekly_time_schedule || []
      };

      // 🔹 PREFILL FOREMAN & WAREHOUSE INPUTS
      this.foremanSearch = d.department_Foreman_name || '';
      this.warehouseSearch = d.warehouse_name || '';
      this.assignedEmployee = this.allEmployees.find(
        e => e.employee_id === d.new_product_id_creator
      ) || null;
      this.selectedStoreResponsible = this.allEmployees.find(
        e => e.employee_id === d.store_incharge_employee_id
      ) || null;
      this.selectedSafetyResponsible = this.allEmployees.find(
        e => e.employee_id === d.safety_responsible_employee_id
      ) || null;
      // prefill search/display field
      this.warehouseSearch = d.warehouse_name || '';
      this.showWarehouseList = false;

      // 🔹 PREFILL COUNTRY DROPDOWN + TIMEZONE LIST (so country also shows correctly)
      this.selectedCountry =
        this.countries.find((c: any) => c.name === d.country_name) || null;

      if (this.selectedCountry) {
        this.timezoneList = countryTimezone.getTimezones(
          this.selectedCountry.name
        );
      }

      if (Array.isArray(d.weekly_time_schedule)) {
        d.weekly_time_schedule.forEach((sched: any) => {
          const dayObj = this.weekdays.find(
            w => w.value === sched.day
          );
          if (dayObj) {
            dayObj.workin_time = sched.workin_time || '';
            dayObj.workout_time = sched.workout_time || '';
            dayObj.lunch_in_time = sched.lunch_in_time || '';
            dayObj.lunch_out_time = sched.lunch_out_time || '';
            dayObj.checked = !!sched.isActive;
          }
        });
      }

      this.model.weekly_working_days = this.weekdays
        .filter(day => day.checked)
        .map(day => day.value);
      // Preload map marker
      if (d.department_latitude && d.department_longitude) {
        const lat = Number(d.department_latitude);
        const lng = Number(d.department_longitude);

        this.mapCenter = { lat, lng };
        this.mapMarkers = [
          {
            position: { lat, lng },
            label: { text: 'Department Location', color: 'red' },
            options: { animation: google.maps.Animation.BOUNCE }
          }
        ];
      }
    });
  }

  // ============================
  // SUBMIT
  // ============================
  submit() {
    const validation = this.validateWeekdayTimes();
    if (!validation.isValid) {
      this.api.showToast('error', validation.message);
      return;
    }

    this.isLoading = true;
    this.model.weekly_time_schedule = this.buildWeeklyTimeSchedule();
    this.api.EditDepartment(this.model).subscribe(res => {
      this.isLoading = false;
      if (res.success) {
        this.api.showToast('success', 'Department updated');
        this.location.back();
      } else {
        this.api.showToast('error', res.message);
      }
    });
  }


  // ============================
  // INIT
  // ============================
  ngOnInit(): void {
  this.loadGoogleMaps();
  this.loadEmployees();
  this.loadWarehouses();
  this.loadCustomers();
  this.loadIndustryTypes();
  this.loadBrands();
  this.loadDeliveryMen();
  }
  private validateWeekdayTimes(): { isValid: boolean; message: string } {
    for (const day of this.weekdays) {
      if (day.checked) {
        if (!day.workin_time || !day.workout_time || !day.lunch_in_time || !day.lunch_out_time) {
          return {
            isValid: false,
            message: `Please fill all time fields (Work in, Work out, Lunch in, Lunch out) for ${day.week}.`
          };
        }
      }
    }
    return { isValid: true, message: '' };
  }
  fillAllTimes() {
    const sourceDay = this.weekdays.find(
      d => d.checked && (d.workin_time || d.workout_time || d.lunch_in_time || d.lunch_out_time)
    );

    if (!sourceDay) {
      this.api.showToast('error', 'Fill the time fields for at least one selected day first.');
      return;
    }

    this.weekdays.forEach(day => {
      if (day.checked) {
        day.workin_time = sourceDay.workin_time;
        day.workout_time = sourceDay.workout_time;
        day.lunch_in_time = sourceDay.lunch_in_time;
        day.lunch_out_time = sourceDay.lunch_out_time;
      }
    });

    this.api.showToast('success', 'Times applied to all selected days');
  }
}
